import { Button } from "@/components/ui/button";
import { Download, Trash2, X } from "lucide-react";

interface Props {
  selectedCount: number;
  onDelete: () => void;
  onExport: () => void;
  onClear: () => void;
  busy?: boolean;
}

export function CoiBulkActionBar({ selectedCount, onDelete, onExport, onClear, busy }: Props) {
  if (selectedCount === 0) return null;
  return (
    <div className="sticky top-0 z-20 bg-background/95 backdrop-blur border rounded-lg px-4 py-2 flex items-center gap-3 shadow-sm">
      <span className="text-sm font-medium">{selectedCount} selected</span>
      <div className="flex-1" />
      <Button size="sm" variant="outline" className="h-8 gap-1.5" onClick={onExport} disabled={busy}>
        <Download className="w-3.5 h-3.5" /> Export CSV
      </Button>
      <Button size="sm" variant="destructive" className="h-8 gap-1.5" onClick={onDelete} disabled={busy}>
        <Trash2 className="w-3.5 h-3.5" /> Delete
      </Button>
      <Button size="sm" variant="ghost" className="h-8 gap-1.5" onClick={onClear}>
        <X className="w-3.5 h-3.5" /> Clear
      </Button>
    </div>
  );
}
